/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import{isNone as n}from"../../core/maybe.js";function e(n){return n&&"function"==typeof n.highlight}function t(n){return n&&"function"==typeof n.maskOccludee}function c(e,t,c){return n(e)||e>c&&(0===t||e<t)}function o(n){let{minScale:e,maxScale:t}=n;return e=e||0,t=t||0,{minScale:e,maxScale:t}}export{o as extractSafeScaleBounds,e as highlightsSupported,t as occludeesSupported,c as scaleBoundsPredicate};
